export default __webpack_public_path__ + "static/media/22 Track 22.8c169e93.mp3";